<template>
  <div class="area-cascader">
    <el-cascader ref="cascader" v-model="value" :options="treeData" :props="options" :show-all-levels="false"
      :placeholder="placeholder || '所属区域'" @change="changeArea" @visible-change="visibleChange" clearable></el-cascader>
  </div>
</template>
<script>
// import { baseUrl } from "@/api/request";
/**
 * lastchildcannot  控制最后一个子区域是否能选择  true不能选择
 * **/
export default {
  props: [
    "handleAreaData",
    "index_num",
    "treeType",
    "placeholder",
    "lastchildcannot",
    "checkStrictly",
  ],
  data() {
    return {
      specificAreaName: "",
      options: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        value: "id",
        label: "areaName",
        children: "children",
        leaf: "hasSub",
        // expandTrigger: "hover",
        checkStrictly: true,
      },
      treeData: [],
      value: [],
    };
  },
  watch: {
    handleAreaData: {
      handler(data) {
        switch (data.type) {
          case 0:
            console.log("执行");
            // 重置-清空
            this.value = [];
            this.$refs.cascader.$refs.panel.checkedValue = []; // 清空选中的数据
            this.$refs.cascader.$refs.panel.clearCheckedNodes(); //选中节点的清除
            this.$refs.cascader.$refs.panel.activePath = []; // 清除高亮
            this.$refs.cascader.$refs.panel.syncActivePath(); //只展示一级节点
            break;
          default:
            break;
        }
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    // this.specificAreaName = baseUrl.split("/")[1];
    this.getAreaTree();
  },
  mounted() { },
  methods: {
    // 获取区域
    async getAreaTree() {
      if (this.treeType == 2) {
        this.$http
          .postAction(this.$api.getSubAreaList + "?areaId=" + 0)
          .then((res) => {
            if (res.code == 200) {
              res.data.forEach((item) => {
                if (item.areaLevel < 3) {
                  item.hasSub = false;
                } else {
                  item.hasSub = true;
                }
              });
              this.treeData = res.data.data || [];
            }
          });
      } else {
        this.treeData = [
          {
            id: "0",
            areaLevel: "1",
            areaSort: "1",
            areaName: "全区域",
            hasSub: false,
          },
        ];
      }
    },
    lazyLoad(node, resolve) {
      console.log(node);
      if (!node.data) {
        return;
      }
      if (node.data.hasSub) {
        resolve([]);
        return;
      }
      this.getDistrict(node, resolve);
    },
    getDistrict(node, resolve) {
      this.$http
        .postAction(this.$api.getSubAreaList + "?areaId=" + node.data.id)
        .then((res) => {
          // console.log(res);
          if (res.code == 200 && res.data) {
            res.data.forEach((item) => {
              if (item.areaLevel < 3) {
                item.hasSub = false;
              } else {
                item.hasSub = true;
              }
            });
            if (this.lastchildcannot) {
              // 最后一集子区域禁止选择
              res.data.forEach((element) => {
                element.disabled = element.hasSub;
              });
            }
            resolve(res.data || []);
          } else {
            resolve([]);
          }
        });
    },
    changeArea(val) {
      // console.log(this.$refs["cascader"].getCheckedNodes()[0]);

      // this.$nextTick(() => {
      //   console.log(val);
      //   console.log(this.$refs["cascader"].getCheckedNodes());
      //   console.log(this.$refs["cascader"].$refs.panel);
      //   const selectedOption = this.$refs["cascader"].$refs.panel.$el;
      //   console.log(selectedOption);
      //   const panel = document.getElementsByClassName("el-cascader-panel")[0];
      //   console.log(panel);
      //   const dom = selectedOption.getElementsByClassName(
      //     "el-radio is-checked"
      //   )[0];
      //   console.log(dom);
      //   const dom1 = panel.getElementsByClassName("el-radio is-checked")[0];
      //   console.log(dom1);
      //   const brother = dom.nextElementSibling;
      //   console.log(brother);
      //   this.$emit("change", val);
      // });
      // 处理清空的情况
      if (!this.$refs["cascader"].getCheckedNodes()[0]) {
        let params = {
          label: "",
          value: "",
        };
        if (this.index_num !== undefined) {
          params.index_num = this.index_num;
        }
        this.$emit("selectArea", params);
        return;
      }
      if (this.index_num !== undefined) {
        let params = {};
        params.label = this.$refs["cascader"].getCheckedNodes()[0].label;
        params.value = this.$refs["cascader"].getCheckedNodes()[0].value;
        params.index_num = this.index_num;
        this.$emit("selectArea", params);
        return;
      }
      this.$emit("selectArea", this.$refs["cascader"].getCheckedNodes()[0]);
      // return;
      // 解决暂无数据问题
      this.$nextTick(() => {
        // const panel = document.getElementsByClassName("el-cascader-panel")[0];
        const panel = this.$refs["cascader"].$refs.panel.$el;
        if (!panel) {
          // 选中后直接关闭下拉
          this.$refs.cascader.dropDownVisible = false;
          return;
        }
        const dom = panel.getElementsByClassName("el-radio is-checked")[0];
        if (!dom) {
          // 选中后直接关闭下拉
          this.$refs.cascader.dropDownVisible = false;
          return;
        }
        const brother = dom.nextElementSibling;
        if (!brother) {
          // 选中后直接关闭下拉
          this.$refs.cascader.dropDownVisible = false;
          return;
        }

        brother.click();
        // 选中后直接关闭下拉
        this.$refs.cascader.dropDownVisible = false;
      });
    },
    // 下拉弹层打开关闭
    visibleChange(bool) {
      console.log(this.value);
      if (bool) {
        if (this.value.length) {
          return;
        }
        console.log("执行");
        this.$refs.cascader.$refs.panel.checkedValue = []; // 清空选中的数据
        this.$refs.cascader.$refs.panel.clearCheckedNodes(); //选中节点的清除
        this.$refs.cascader.$refs.panel.activePath = []; // 清除高亮
        this.$refs.cascader.$refs.panel.syncActivePath(); //只展示一级节点
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.area-cascader {
  width: 100%;
  // height: 100%;
  height: .45rem;

  ::v-deep .el-cascader {
    height: .45rem;
    transform: translateY(-2px);

    .el-icon-arrow-down:before {
      content: '\e78f';
    }
    .el-input__icon {
      line-height: .45rem;
    }
    .el-input .el-icon-arrow-down {
      transform: rotateZ(180deg);
    }
    .el-input .el-icon-arrow-down.is-reverse {
      transform: rotateZ(0deg);
    }
  }

}
</style>
